<template>
    <div :ref="id"></div>
</template>

<script>
    import QRCode from 'qrcodejs2';

    const correctLevel = [
        'QRCode.CorrectLevel.L',
        'QRCode.CorrectLevel.M',
        'QRCode.CorrectLevel.Q',
        'QRCode.CorrectLevel.H'
    ]
    export default {
        name: 'base-qrocde',
        props: {
            url: {
                type: String,
                default: null
            },
            width: {
                type: Number,
                default: 100
            },
            height: {
                type: Number,
                default: 100
            },
            colorDark: {
                type: String,
                default: '#000'
            },
            colorLight: {
                type: String,
                default: '#fff'
            },
            colorLev: {
                type: Number,
                default: 3
            }
        },
        watch: {
            url(_new, _old) {
                if (_new && _new != _old) {
                    this.handleReset();
                } 
            }
        },
        mounted() {
            if (this.url) {
                this.init();
            }
        },
        methods: {
            init() {
                this.qrcode = new QRCode(this.$refs[this.id], {
                    width: this.width,  
                    height: this.height,
                    text: this.url, // 二维码地址
                    colorDark : this.colorDark,
                    colorLight : this.colorLight
                })
            },
            handleQrClear() {
                if (!this.qrcode) return false;
                this.qrcode.clear();
            },
            handleReset() {
                if (!this.qrcode) return false;
                this.qrcode.makeCode(this.url);
            }
        },
        data() {
            return {
                id: `base-qrcode-${parseInt(Math.random() * 1000)}`,
                qrcode: null
            }
        }
    }
</script>